import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountingReviewReportExportType } from '../../../../../../../core/enums/commerce/report/accounting-review-report-export-type';
import { FormGroupType } from '../../../../../../../core/models/form-group-type';
import { AccountingReviewReportFormModel } from '../models/accounting-review-report-form-model';

@Injectable({
    providedIn: 'root',
})
export class AccountingReviewReportFormService {
    getFormDefinition(): FormGroup<
        FormGroupType<AccountingReviewReportFormModel>
    > {
        return new FormGroup<FormGroupType<AccountingReviewReportFormModel>>({
            startDate: new FormControl<Date | null>(this.getYesterdayDate(), {
                validators: [Validators.required],
            }),
            endDate: new FormControl<Date | null>(new Date(), {
                validators: [Validators.required],
            }),
            reportType:
                new FormControl<AccountingReviewReportExportType | null>(null, {
                    validators: [Validators.required],
                }),
        });
    }

    private getYesterdayDate(): Date {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        return yesterday;
    }
}
